export function parseArticles({
  articles = []
}) {

  try {

    const articlesParsed = articles.map(article => {

      let upc = "";

      if(!Array.isArray(article)) return null;

      const attributes = []

      for(const attribute of article) {

        if(attribute?.headerId === 'upc') {
          upc = attribute?.value;
          continue;
        }

        const isAttributeValid = ValidateAttribute({
          attribute: {
            isObligatory: attribute?.obligatory === "Obligatorio",
            value: attribute?.value
          }
        });

        if(!isAttributeValid) throw new Error(`Error en el atributo de la celda: ${attribute?.address}, favor de revisar atributos obligatorios`);

        attributes.push(({
          attribute_id: attribute?.headerId,
          obligatory: attribute?.obligatory === "Obligatorio",
          value: attribute?.value,
          type: attribute?.type,
          is_description: parseInt(attribute?.isDescription ?? '-1')
        }));

      }

      return {
        upc,
        attributes
      }

    })

    return {
      data: articlesParsed
    }

  } catch (error) {
    return {
      error: error?.message ?? 'Error desconocido'
    }
  }
}

function ValidateAttribute({
  attribute: {
    isObligatory = false,
    value = ""
  }
}) {

  if(isObligatory && !value)
    return false;

  if(isObligatory && value.toString().trim() === "")
    return false;

  return true;
}